import React, { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'

function ModalVisitComp({
    openModalVisit,
    setOpenModalVisit,
    visitPlace,
    setVisitPlace,
    handleSubmitVisitIn,
    handleCloseModal,
    disabled,
    isSubmitting
}) {


    return (
        <Modal
            show={openModalVisit}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            centered
        >

            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Visit Masuk
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitVisitIn} >
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='visitPlace'>Lokasi Visit*</Form.Label>
                        <Form.Control
                            id='visitPlace'
                            type="text"
                            value={visitPlace}
                            onChange={(e) => setVisitPlace(e.target.value)}
                            disabled={disabled}
                            required
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <div className="d-grid gap-2">
                        {isSubmitting ? (
                            <Button
                                type="submit"
                                // id='actionButtonLogin'
                                variant='btn'
                                disabled={disabled}
                                style={{ backgroundColor: '#12B3ED', color: 'white', fontFamily: 'Poppins-Regular' }}>
                                <Spinner animation="border" size='sm' style={{ color: '#FFFFFF' }} />
                            </Button>
                        ) : (
                            <Button
                                variant="btn"
                                type='submit'
                                style={{ backgroundColor: '#12B3ED', color: 'white', fontFamily: 'Poppins-Regular' }}>
                                Kirim
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalVisitComp


const formStyles = {
    label: {
        fontFamily: 'Poppins-Medium',
        color: '#222',
    },
    input: {
        color: '#222',
        fontFamily: 'Poppins-Regular',
        minHeight: '50px',
        borderColor: '#ced4da', // Initial border color
    },
};
